import type { ReactNode } from 'react';

export type BadgeTone = 'brand' | 'accent' | 'safe' | 'sun' | 'neutral' | 'gradient';

const TONES: Record<BadgeTone, string> = {
  brand: 'bg-brand-50 text-brand-700 ring-brand-100',
  accent: 'bg-accent-50 text-accent-700 ring-accent-100',
  safe: 'bg-safe-50 text-safe-700 ring-safe-200',
  sun: 'bg-sun-50 text-sun-700 ring-sun-200',
  neutral: 'bg-slate-100 text-slate-600 ring-slate-200',
  gradient: 'bg-brand-gradient text-white ring-transparent',
};

export function Badge({
  children,
  tone = 'brand',
  icon,
  className = '',
}: {
  children: ReactNode;
  tone?: BadgeTone;
  icon?: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold ring-1 ring-inset ${TONES[tone]} ${className}`}
    >
      {icon}
      {children}
    </span>
  );
}
